import { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../../utils/api';
const API =  process.env.REACT_APP_API_URL;

export default function AdminLowStock() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get(`${API}/api/admin/products/low-stock`).then(res => setProducts(res.data));
  }, []);

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Low Stock Products</h2>
      {products.length === 0 ? <p>No low stock products!</p> : (
        <ul className="space-y-2">
          {products.map(p => (
            <li key={p.id} className="border p-2 flex justify-between">
              <span>{p.name} ({p.variants?.filter(v => v.stock < 5).map(v => `${v.size}/${v.color}: ${v.stock}`).join(', ')})</span>
              <span className="text-red-500 font-semibold">Low Stock</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}